/**
 * CLEARO bundle offer card — <clearo-offer>
 * Keeps "2 for …" and "You save …" in step with the selected variant, and
 * "Add 2 to cart" sets the quantity to 2 and submits the normal product form,
 * so Origin's cart drawer and the automatic discount do the rest.
 * Markup: snippets/clearo-offer.liquid
 */
(() => {
  if (customElements.get('clearo-offer')) return;

  const formatMoney = (cents, format) => {
    const withDelims = (n, decimals, thousands, decimal) => {
      const [int, frac] = (n / 100).toFixed(decimals).split('.');
      return int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (frac ? decimal + frac : '');
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => {
      switch (key) {
        case 'amount_no_decimals':
          return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withDelims(cents, 0, '.', ',');
        default:
          return withDelims(cents, 2, ',', '.');
      }
    });
  };

  class ClearoOffer extends HTMLElement {
    connectedCallback() {
      this.info = this.closest('product-info') || document;
      this.percent = parseFloat(this.dataset.percent) || 0;
      this.format = this.dataset.moneyFormat || '{{amount}}';
      try {
        this.prices = JSON.parse(this.querySelector('[data-variants]').textContent);
      } catch (e) {
        this.prices = {};
      }
      this.pairEl = this.querySelector('[data-pair]');
      this.saveEl = this.querySelector('[data-save]');
      this.pairTpl = this.querySelector('[data-pair-template]').innerHTML.trim();
      this.saveTpl = this.querySelector('[data-save-template]').innerHTML.trim();

      this.querySelector('[data-add-two]').addEventListener('click', () => this.addTwo());

      if (window.subscribe && window.PUB_SUB_EVENTS) {
        this.unsubscribe = window.subscribe(window.PUB_SUB_EVENTS.variantChange, () => this.update());
      }
      this.info.addEventListener('change', () => setTimeout(() => this.update(), 80));
    }

    disconnectedCallback() {
      this.unsubscribe && this.unsubscribe();
    }

    get idInput() {
      return this.info.querySelector('form[action*="/cart/add"] input[name="id"]');
    }

    update() {
      const input = this.idInput;
      const price = input && this.prices[input.value];
      if (typeof price !== 'number') return;
      const save = Math.floor((price * this.percent) / 100);
      const pair = price * 2 - save;
      const pairText = this.pairTpl.replace('__PRICE__', formatMoney(pair, this.format));
      const saveText = this.saveTpl.replace('__PRICE__', formatMoney(save, this.format));
      if (this.pairEl.dataset.raw !== pairText) {
        this.pairEl.dataset.raw = pairText;
        this.pairEl.textContent = pairText;
      }
      if (this.saveEl.dataset.raw !== saveText) {
        this.saveEl.dataset.raw = saveText;
        this.saveEl.textContent = saveText;
      }
    }

    addTwo() {
      const qty = this.info.querySelector('.quantity__input');
      const addBtn = this.info.querySelector('form[action*="/cart/add"] [name="add"]');
      if (!addBtn || addBtn.disabled) return;
      if (qty) {
        qty.value = 2;
        qty.dispatchEvent(new Event('change', { bubbles: true }));
      }
      this.classList.add('is-adding');
      addBtn.click();
      // Back to 1 for the next add, once the cart request has gone out
      setTimeout(() => {
        this.classList.remove('is-adding');
        if (qty) {
          qty.value = 1;
          qty.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 1500);
    }
  }

  customElements.define('clearo-offer', ClearoOffer);
})();
